import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import store from "@/store";

@Module({namespaced: true, name: "appSettings", store: store})
export default class AppSettingsModule extends VuexModule {
    private _autoLogoutEnabled: boolean = true;
    private _autoLogoutUntilWarn: number = 0;
    private _autoLogoutAfterWarn: number = 0;

    get autoLogoutEnabled(): boolean {
        return this._autoLogoutEnabled;
    }

    get autoLogoutUntilWarn(): number {
        return this._autoLogoutUntilWarn;
    }

    get autoLogoutAfterWarn(): number {
        return this._autoLogoutAfterWarn;
    }

    @Mutation
    setAutoLogoutEnabled(enabled: boolean) {
        this._autoLogoutEnabled = enabled;
    }

    @Mutation
    setAutoLogoutUntilWarn(value: number) {
        this._autoLogoutUntilWarn = value;
    }

    @Mutation
    setAutoLogoutAfterWarn(value: number) {
        this._autoLogoutAfterWarn = value;
    }

    @Action({rawError: true})
    async initialize() {
        this.setAutoLogoutEnabled(AppSettingsModule.convertToBoolean(process.env.VUE_APP_LOGOUT_ENABLED, true));
        this.setAutoLogoutUntilWarn(process.env.VUE_APP_LOGOUT_UNTIL_WARN_S);
        this.setAutoLogoutAfterWarn(process.env.VUE_APP_LOGOUT_AFTER_WARN_S);
    }

    private static convertToBoolean(value: string, defaultValue: boolean): boolean {
        if (value === undefined) {
            return defaultValue;
        }

        return value.toLowerCase() === "true";
    }
}
